/**
 * Created by chuongnv 2017/09/28.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiEvsService} from './ApiEvs.service';

@Injectable()

export class EvsUserService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
    this.setEndPoint('');
  }

  listOwner() {
    return this.get('/owner');
  }

  acceptInvitation(id: any) {
    return this.get('/owner/accept/' + id);
  }

  loginByOwner(id: any) {
    return this.post('/owner/' + id + '/login');
  }

  leaveOwner(id: any) {
    return this.get('/owner/leave/' + id);
  }

  getListStaff(data?: any) {
    return this.get('/staffs', data);
  }

  getEmployees(data?: any) {
    return this.get('/employees', data);
  }

  createStaff(data?: any) {
    return this.post('/create-account', data);
  }

  getPermissions(id?: any) {
    return this.get('/permissions?user_id=' + id);
    // return this.get('/permissions');
  }

  getRoles(id?: any) {
    return this.get('/roles?user_id=' + id);
    // return this.get('/permissions');
  }

  setPermission(id, data: any) {
    return this.post('/add-permission/' + id, data);
    // return this.get('/permissions');
  }

  reset_password(uid: any, data: any) {
    return this.post('/reset-password/' + uid, data);
  }

  delete_account(uid: any) {
    return this.delete('/staff/' + uid);
  }

  undeleted_staff(uid: any) {
    return this.put('/staff/undelete/' + uid);
  }

  actionKickStaff(id: any) {
    return this.get('/staff/kick/' + id);
  }

  actionInviteStaff(icheck_id: any) {
    return this.get('/staff/invite/' + icheck_id);
  }

  getListRole() {
    return this.get('/roles');
  }

  setRoleStaff(data: any) {
    return this.post('/staff/role', data)
  }

  searchStaff(data: any) {
    return this.get('/users/detail', data);
  }

  getMaganerPermission(id?: any, data?: any) {
    return this.get('/advance-permission/' + id, data)
  }

  postMaganerPermission(id?: any, data?: any) {
    return this.post('/advance-permission/' + id, data)
  }

  deleteMaganerPermission(id?: any, data?: any) {
    return this.delete('/advance-permission/' + id, data)
  }

  updateStaff(id, body) {
    return this.put('/account/' + id, body);
  }

  getListSuggestStamp(code?: any, page?: any, size?: any) {
    return this.get_qr_core_aps(`/map_code/search_relative?code=${code}&page=${page}&size=${size}` )
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/EvsUser.service.ts